/* eslint-disable no-param-reassign */
import { MembershipWithCurrentPlayer } from '../../../app/containers/Tournaments/types/Membership'
import ScoreboardBuilder from './Templates/ScoreboardRow'
import { TOURNAMENT_WIDGET_POSITION_KEY } from './constants'
import { Coordinates } from './types'

export const toggleVisibility = (element: HTMLElement, toggler: HTMLElement) => {
  const isOpen = element.style.display === 'block'

  if (isOpen) {
    hide(element)
    toggler.classList.remove('close')
  } else {
    show(element)
    toggler.classList.add('close')
  }
}

export const show = (element: HTMLElement) => {
  element.style.display = 'block'
}

export const hide = (element: HTMLElement) => {
  element.style.display = 'none'
}

export const savePosition = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect()

  const position = {
    top: rect.top,
    left: rect.left,
    right: rect.right,
    bottom: rect.bottom,
  }

  window.localStorage.setItem(TOURNAMENT_WIDGET_POSITION_KEY, JSON.stringify(position))
}

export const getPosition = (): Coordinates =>
  JSON.parse(window.localStorage.getItem(TOURNAMENT_WIDGET_POSITION_KEY) || '{}') as Coordinates

export function isInViewport({ top, left, bottom, right }: Coordinates) {
  return (
    top >= 0 &&
    left >= 0 &&
    bottom <= (document.documentElement.clientHeight || window.innerHeight) &&
    right <= (document.documentElement.clientWidth || window.innerWidth)
  )
}

export function updateScoreBoard(table: HTMLTableElement, users: MembershipWithCurrentPlayer[]) {
  const scoreboardBuilder = new ScoreboardBuilder(table)
  users.forEach((user) => scoreboardBuilder.addUser(user))
  table.replaceWith(scoreboardBuilder.getTable())
}
